export class ItemNotPlayableYet extends Error {
  constructor() {
    super('Item is not playable yet');
  }
}

